import { ReactComponent as IconDevice } from "assets/svg/menu-device.svg"
import { ReactComponent as IconOrders } from "assets/svg/menu-orders.svg"

import { useNewOrdersQuantity } from "hooks/useNewOrdersQuantity"

import { MenuBadge, MenuItem } from ".."

export const WarehouseMenu = () => {
  const { data } = useNewOrdersQuantity()

  return (
    <>
      <MenuItem
        to="/wh-orders"
        icon={<IconOrders />}
        label="Orders"
        badge={<MenuBadge count={data?.data?.quantity} />}
      />

      <MenuItem to="/wh-devices" icon={<IconDevice />} label="Devices" iconType="stroke" />
    </>
  )
}
